<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle Users Menu">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button mat-raised-button color="primary" id="add" [routerLink]="['/admin', 'users', 'new', 'edit']" class="m-1 mr-2">
          <mat-icon>add</mat-icon> Add User
        </button>

        <button mat-raised-button id="import" [routerLink]="['/admin', 'users', 'documents', 'importer']" class="m-1 mr-2">
          <mat-icon>cloud_upload</mat-icon> Import User Documents
        </button>

        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.deselectAll()">
            Deselect All
          </button>

          <button mat-menu-item (click)="composeNewMessage()" [disabled]="!dataSource.selection.hasValue()" matTooltip="Click this button to send a message to the selected users.">
            Send Message
          </button>
        </mat-menu>

        <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="System Administrators Menu" *ngIf="dataSource.selection.hasValue()" style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </span>

      <button
        mat-raised-button
        class="m-1 mr-lg-3"
        [color]="hasActiveFilters ? 'primary' : null"
        (click)="onOpenFilters()"
        matTooltip="Click this button to display filter options for this list.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search Users"
          aria-label="Search"
          id="search-input"
          matTooltip="Search all users by name." />

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Search all users.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="id" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Select All Visible Users">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let user">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(user.id) : null"
            [checked]="dataSource.selection.isSelected(user.id)"
            matTooltip="Select User {{user.id}}">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by ID">
          #
        </th>
        <td mat-cell *matCellDef="let user">
          {{ user.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="icons">
        <th mat-header-cell *matHeaderCellDef>Status Icons</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon matTooltip="Connected to the {{ utils.getAppName() }} mobile app{{ element.version ? (', using version ' + element.version) : ''}}." *ngIf="element.device_id">
            phonelink_setup
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="contact_person">
        <th mat-header-cell mat-sort-header *matHeaderCellDef   matTooltip="Sort by Full Name">
          Full Name
        </th>
        <td mat-cell *matCellDef="let user">
          <a (click)="onUserPublicView(user.hash)"
             matTooltip="View User Public Profile">
            {{ user.contact_person }}
          </a>
          <!-- Manual block (SC-3089). Distinct from the verification "Sign-in blocked" label. -->
          <span class="badge badge-danger ml-1" *ngIf="user.is_blocked" [matTooltip]="blockedTooltip(user)">Blocked</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by Email Address">
          Email Address
        </th>
        <td mat-cell *matCellDef="let user">
          {{ user.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by {{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }}">
          {{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }}
        </th>
        <td mat-cell *matCellDef="let user">
          {{ user.mobile }}
        </td>
      </ng-container>

      <ng-container matColumnDef="employer">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by Employer">
          Employer
        </th>
        <td mat-cell *matCellDef="let user">
          {{ '#' + user.account_id }} <br>
          {{ user.employer }}
        </td>
      </ng-container>

      <ng-container matColumnDef="is_sitesoft_admin">
        <th mat-header-cell *matHeaderCellDef matTooltip="Whether this user is a support (super admin) user.">
          Type
        </th>
        <td mat-cell *matCellDef="let user">
          <span [ngClass]="{ 'badge badge-warning': user.is_sitesoft_admin }" [matTooltip]="user.is_sitesoft_admin ? ('This user is a ' + utils.getAppName() + ' support user with elevated system access.') : ''">
            {{ user.is_sitesoft_admin ? 'Support' : 'Regular' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by Date Joined">
          Date Joined
        </th>
        <td mat-cell *matCellDef="let user">
          {{ (user.date_created * 1000) | timezoneConvertShort }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by Date Joined">
          Date Joined(UTC)
        </th>
        <td mat-cell *matCellDef="let user">
          {{ (user.date_created * 1000) | timezoneConvertUTCShort }}
        </td>
      </ng-container>

      <ng-container matColumnDef="verification">
        <th mat-header-cell *matHeaderCellDef>
          <div class="d-flex align-items-center">
            <span>Verification</span>
            <button
              type="button"
              mat-icon-button
              class="verification-help-button"
              aria-label="Explain verification statuses"
              matTooltip="What do these statuses mean?"
              (click)="onOpenVerificationLegend()">
              <mat-icon>help_outline</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let user">
          <div class="d-flex align-items-center" [matTooltip]="verificationTooltip(user)">
            <mat-icon
              class="mr-1"
              aria-hidden="true"
              [color]="verificationDisplay(user).color"
              [class.verification-neutral]="!verificationDisplay(user).color">
              {{ verificationDisplay(user).icon }}
            </mat-icon>
            <div class="d-flex flex-column">
              <span class="verification-label">{{ verificationDisplay(user).label }}</span>
              <!-- Only the blocked states get a second line, so the common cases stay compact. -->
              <span
                class="verification-sub-label text-danger"
                *ngIf="verificationBlocked(user)"
                [matTooltip]="verificationBlockedTooltip">
                Sign-in blocked
              </span>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="200"></th>
        <td mat-cell *matCellDef="let user">
          <div class="d-flex align-items-center">
            <button
              type="button"
              mat-button
              [routerLink]="'/admin/users/' + user.id + '/edit'"
            >
              Edit
            </button>

            <button type="button" mat-icon-button [matMenuTriggerFor]="rowMenu" matTooltip="More actions">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
          <mat-menu #rowMenu="matMenu">
            <button type="button" mat-menu-item (click)="composeNewMessage(user.id)">
              <mat-icon>email</mat-icon>
              <span>Send Message</span>
            </button>
            <button type="button" mat-menu-item (click)="onUnlockUser(user.id)">
              <mat-icon>lock_open</mat-icon>
              <span>Unlock</span>
            </button>
            <button type="button" mat-menu-item (click)="onResendVerification(user)">
              <mat-icon>mark_email_read</mat-icon>
              <span>Resend Verification</span>
            </button>
            <mat-divider></mat-divider>
            @if (canBlockUser(user)) {
              <button type="button" mat-menu-item class="text-danger" (click)="onBlockUser(user)">
                <mat-icon color="warn">block</mat-icon>
                <span>Block user</span>
              </button>
            }
            @if (user.is_blocked) {
              <button type="button" mat-menu-item (click)="onUnblockUser(user)">
                <mat-icon>how_to_reg</mat-icon>
                <span>Unblock user</span>
              </button>
            }
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
